
/**
 * Add a domain App declaration (couldn't come up with clever name).
 */
var domainApp = angular.module('domainApp', ['ngAnimate', 'ngRoute', 'rt.encodeuri', 'ngSanitize', 'pop.directives']);

domainApp.config(function($routeProvider, $locationProvider) {
  $routeProvider
    .when('/', {
      controller:'MainCtrl',
      templateUrl:'/panel/js/domains/views/searchview.html',
    })
    .when('/whois/:domain', {
    	controller:'WhoisCtrl',
    	templateUrl:'/panel/js/domains/views/whoisview.php'
    })
    .when('/buy/:domain', {
      controller:'BuyCtrl',
      templateUrl:'/panel/js/domains/views/buyview.html',
    })
    .otherwise({
      redirectTo:'/'
    });
});

/**
 * Add a domain App first view controller.
 */
domainApp.controller('MainCtrl', function($scope, domainService, $rootScope) {
	$scope.messages = {
		"default": "",
		"domainError": "The domain name or keywords you entered contains invalid characters. Please only use a combination of letters, numbers, hyphens, and spaces, and a period if you are searching for an exact match domain.",
		"available": "This domain name is available.",
                "available_similar": "This domain is available. Pick it or one of our other suggestions below.",
		"notavailableempty": "This domain is not available. Please try another one!",
		"notavailable": "This domain is not available. Pick from one of the suggestions below or try another one!",
		"blacklisted": "This domain contains a blacklisted keyword! Please try another one.",
		"gapps": "This domain has been registered with Google Apps!"
	};

	$rootScope.ajax = false;

	if (!$rootScope.formData) {
		$rootScope.formData = {};
	} else {
		$rootScope.formData.domain = null;
	}

	// clear messaging
	domainService.clearMessages('#messageBox');

	// check if we have a selected domain
	if ($rootScope.selectedDomain) {
		$scope.domain = $rootScope.selectedDomain.Domain;
		$scope.suggestions = $rootScope.suggestions;
		$scope.dontSearch = true;

		$rootScope.formData.domain = $scope.domain;
	}

	// reset messaging
	domainService.showMessage('#messageBox', [], 'default');

	// make call to get the tld list
	domainService.loadTlds().then(function(data) {
		$scope.tlds = data.tld;
	}, function(error) {
		void 0;
	});

	$scope.setSelectedDomain = function(domain) {
		$rootScope.formData.domain 	= domain.Domain;
		$rootScope.selectedDomain 	= domain;
		$rootScope.suggestions 		= $scope.suggestions;
	}
});

/**
 * TODO: Add WHOIS information.
 */
domainApp.controller('WhoisCtrl', function($scope, domainService, validationHelper, $rootScope, $location) {
	// disallow if we dont have a domain selected
	if (typeof $rootScope.selectedDomain == 'undefined' || !$rootScope.selectedDomain) {
		$location.path('/');
		return;
	}

	// clear messaging
	domainService.clearMessages('#whoisMessageBox');

	// scroll to where we need
	POP.scrollTo('#add-domain', true, true);

	// set some default values 
	if (!$rootScope.formData || !$rootScope.formData.whois_country) {
		$rootScope.formData.whois_country = 'US';
	    $rootScope.formData.whois_phone_countrycode = 'US';
	    $rootScope.formData.whois_phone_countrycode_numeric = 1;
	    $rootScope.formData.whois_phone = '+1 ';
	    $rootScope.formData.privacy_enabled = 1;
	}

    $rootScope.whoisPhoneErrors = false;
    $rootScope.validWhoisPhone = false;
    $rootScope.validWhois = false;

    // watch for valid form
	$scope.$watch('formWhois.$valid', function() {
        $rootScope.validWhois = $scope.formWhois.$valid;
    });

	/**
	 * Validate this step.
	 */
	$scope.isCurrentStepValid = function() {
		return $rootScope.validWhois;
	}

	/**
	 * Back to search view. Is there a way to show previous results?
	 */
	$scope.prevStep = function() {
		$location.url('/');
	}

	/**
	 * Handle validating our WHOIS data.
	 */
    $rootScope.validateWhois = function() {
        // perform overall verification, if successful then route to verify
        validationHelper.validateWhois($rootScope).then(function(resp) {
            if (resp.code === 200) {
                $location.url('/buy/' + $rootScope.formData.domain);
            } else {
                if (typeof resp.rules != 'undefined') {
                    validationHelper.setFieldErrors(resp.rules, $rootScope, 'formWhois')
                } 

                if (typeof resp.errors != 'undefined' && resp.errors) {
					domainService.showMessage('#whoisMessageBox', [resp.msg], 'danger', resp.errors);
                } else {
					domainService.showMessage('#whoisMessageBox', [resp.msg], 'danger');
                }
            }
        }).catch(function(e) {
            // display errors here
            void 0;

			domainService.showMessage('#whoisMessageBox', ['An error occurred attempting to validate your WHOIS contact information.'], 'danger');
        });
    }
});


/**
 * Add a domain App buy view controller.
 */
domainApp.controller('BuyCtrl', function($scope, domainService, $routeParams, $rootScope, $location) {
	// not sure when this comes into play
	if (typeof $rootScope.selectedDomain == 'undefined') {
		$location.path('/');
		return;
	} 

	// clear messaging
	domainService.clearMessages('#buyMessageBox');

	$scope.user = POP.currentUser;
	$scope.selectedDomain = $rootScope.selectedDomain;
	$scope.success = false;
	$scope.confirm_terms = false;
	$scope.total = 0;
	$scope.apiBaseUrl = POP.apiBaseUrl;
	$scope.billingMessage = "We'll need your billing information first!";

	$scope.shareText = 'I just registered the domain ' + $scope.selectedDomain.Domain + ' with @POPdotco! Damn that was easy!';

    // scroll to where we need
	POP.scrollTo('#add-domain', true, true);

    domainService.showMessage(
        '#buyMessageBox',
        ["You get the domain <strong>" + $scope.selectedDomain.Domain + "</strong> and access to all of the additional services below when you click <strong>Buy Domain</strong> below."],
        'info'
    );
	
	/**
	 * Simple calculation of domain pricing.
	 */
	$scope.calculateTotal = function() {
		var total = 0;
		
		if (typeof $scope.selectedDomain != 'undefined') {
			total = $scope.selectedDomain.price;
		}

		return total;
	}

	/**
	 * Check if a billing modal is required.
	 */
    $scope.requireBillingModal = function() {
        return POP.currentUser == '' || POP.currentUser.status.billing_enabled == 0;
    }

    /**
     * Change the button text depending on the user status.
     */
    $scope.getBillingButtonText = function() {
    	if ($scope.requireBillingModal()) {
    		return 'Enter Billing Information';
    	} else {
    		return 'Buy Domain';
    	}
    }

    /**
     * Handle registration.
     */
	$scope.register = function() {
		// do a check to see if this is a premium domain
        if ($scope.requireBillingModal()) {
        	void 0;

        	$('#modalMessageBox').removeClass('').empty();
			$scope.showModal = true;
		} else {
			void 0;

			$scope.registerConfirmed();
		}
	}

	/**
	 * Trigger the actual domain registration for an existing account.
	 */
	$scope.registerConfirmed = function() {
		// trigger domain registration
		domainService.registerDomain(
			$rootScope.formData,
			$scope.selectedCategory ? $scope.selectedCategory : null, 
			$scope.selectedPurpose ? $scope.selectedPurpose : null
		).then(function(resp){
			if (resp.code === 200) {
				// hide info && remove "register" button
				$scope.success = true;

				// display success
				domainService.showMessage(
					'#buyMessageBox', 
					['Bravo! Your domain ' + $scope.selectedDomain.Domain + ' has been registered.']
				);

				// switch newly registered domain to active domain
				Panel.getDomains(function() {
					if (POP.domainList && POP.domainList.length) {
						var newDomain = POP.domainList[POP.domainList.length - 1];
						Panel.setCurrentDomain(newDomain.id, false);
					}
				});
			} else {
				// handle max signups
				if (resp.max_signups === true) {
					domainService.showMessage('#buyMessageBox', resp.msg);
					return false;
				}

				// if we have an unauthorized request, show the error (why did we used to open modal?)
				if (resp.code === 401) {
					domainService.showMessage('#buyMessageBox', resp.msg, 'danger');
				}

				// display error message
				if (resp.code === 202) {
					$scope.success = true;
					$scope.inprogress = true;

					domainService.showMessage(
						'#buyMessageBox', 
						["<strong>Thanks!</strong> Your domain registration is in progress and will be active shortly. Please visit the <a href='/panel/domains/manage/'>Manage Domains</a> page to follow its status."], 
						'warning'
					);
				} else {
					if (typeof resp.errors != 'undefined' && resp.errors) {
						domainService.showMessage('#buyMessageBox', [resp.msg], 'danger', resp.errors);
					} else {
						domainService.showMessage('#buyMessageBox', [resp.msg], 'danger');
					}
				}	

				// scroll to where we need
				POP.scrollTo('#add-domain', true, true);		
			}
		}, function(e) {
			void 0;
		});
	}

	/**
	 * Handle credit card success.
	 */
	$scope.ccMatrixSuccess = function(resp) {
		if (resp.code == 200) {
			if (typeof _kmq != 'undefined') {
				_kmq.push(['record','Service-' + $scope.service.slug + '-Converted-Paid']);
			}

			// flag user as billing enabled
			POP.currentUser.status.billing_enabled = 1;

			// initiate registration
			$scope.registerConfirmed();

			// hide the modal
			$scope.showModal = false;
		} else {
			void 0;

			$rootScope.submitForm = false;
			POP.Message.response($('#modalMessageBox'), resp, false, true, false);
		}
	}

	/**
	 * Handle billing information failure.
	 */
	$scope.ccMatrixError = function(error) {
		void 0;

		POP.Message.response($('#modalMessageBox'), error);
	}
});

domainApp.factory('validationHelper', ['$http', '$q', '$rootScope', function($http, $q, $rootScope) {
	var validationHelper = {};

    /**
     * Handles WHOIS contact validation.
     */
    validationHelper.validateWhois = function($scope) {
        var deferred = $q.defer(),
            fields = ['whois_name','whois_email','whois_address_line1','whois_address_line2',
                'whois_city','whois_state','whois_zip','whois_country','whois_phone',
                'whois_phone_countrycode','whois_phone_countrycode_numeric','privacy_enabled'],
            data = angular.copy($scope.formData),
            whoisData = {},
            field, i, j;

        // update whois data with subset of fields
        for (i in fields) {
            field = fields[i];
            for (j in data) {
                if (field == j && !whoisData[field]) {
                    whoisData[field] = data[j];
                }
            }
        }

        // add the domain
        whoisData.domain = $scope.selectedDomain.Domain;

        // trigger ajax
        $scope.ajax = true;

        void 0;

        // handle the attempted registration with form data
        $http
            .post(POP.apiBaseUrl + '/register/validate/whois', whoisData)
            .success(function(response) {
                // untrigger ajax
                $scope.ajax = false;

                void 0;
                void 0;

                // check for errors
                if (!response || !response.code || response.code != 200) {
                    // track the funnel
                    POP.trackFunnel('signup/secondary/whois-validation-failed');

                    // handle rejection
                    validationHelper.generateRejectResponse($scope, deferred, response);
                } else {
                    // track the funnel
                    POP.trackFunnel('signup/secondary/whois-validation-passed');

                    // resolve with response data
                    deferred.resolve(response);
                }
            })
            .error(function(response) {
                // untrigger ajax
                $scope.ajax = false;

                void 0;
                void 0;

                // track the funnel
                POP.trackFunnel('signup/secondary/whois-validation-failed');

                deferred.reject({
                    code: 500,
                    msg: 'An error occurred during validation.'
                });
            });

        // return the promise
        return deferred.promise;
    }

    /**
     * Given a specific set of validation errors coming from the API response, set the validity of the fields.
     */
    validationHelper.setFieldErrors = function(rules, $rootScope, formName) {
        for (var field in rules) {
            for (var rule in rules[field]) {
                void 0;
                //$rootScope[formName][field].$setValidity(rule, false);
            }
        }
    }

    /**
     * Given the scope, a deferred, and a response, handle generating a
     * response error message and flag any erroneous fields with their
     * accompanying validation errors.
     */
    validationHelper.generateRejectResponse = function($scope, deferred, response) {
        if (response.errors) {
            deferred.resolve(response);
        } else if (response.msg) {
            deferred.resolve({
                code: 500,
                msg: response.msg
            });
        } else {
            deferred.resolve({
                code: 500,
                msg: 'An unknown error has occurred processing your request. Please try again. If the problem persists, please contact support.'
            });
        }
    }

    return validationHelper;
}]);

domainApp.factory('domainService', function($http, $q, $rootScope) {
	var data = [],
		service = {},
		deferred,
		canceller;

	service.clearMessages = function(el) {
		var $el = $(el);

		$el.removeClass('alert-info');
		$el.removeClass('alert-danger');
		$el.removeClass('alert-warning');

		$rootScope.activealerts = [];
	}

	service.showMessage = function(el, msgArray, style, errors) {
		var $el = $(el);

		$el.removeClass('alert-info');
		$el.removeClass('alert-danger');
		$el.removeClass('alert-warning');

		if (style === 'danger' || style === 'warning') {
			$el.addClass('alert-' + style);
		} else if (style != 'default') {
			$el.addClass('alert-info');
		}

		// handle errors
		if (typeof errors != undefined && errors) {
            void 0;
            void 0;

            var msg = '<ul>';
            for (field in errors) {
                if (typeof errors[field].msg != 'undefined') {
                    msg += '<li>' + errors[field].msg + '</li>';
                } else {
                	if (typeof errors[field] == 'string') {
                		msg += '<li>' + errors[field] + '</li>';
                	} else {
                		for (key in errors[field]) {
	                        msg += '<li>' + errors[field][key] + '</li>';
	                    }
                	}
                }
            }
            msg += '</ul>';
            msgArray.push(msg);
		}

		// set our active alerts
		$rootScope.activealerts = msgArray;

		// if we have messaging, scroll to it
		if (msgArray && msgArray.length) {
			//POP.scrollTo($el, true, true);
			POP.scrollTo('#add-domain', true, true);
		}
	}

	// load tlds data for this domain
	service.loadTlds = function() {
		if (deferred) {
			deferred.reject();
		}

		deferred = $q.defer();

		ajaxCall('/domains/tld', 'GET', null, function(resp) {
			if (resp.code == 200) {
				data = resp.data;
				deferred.resolve(data);
			} else {
				//display error message somewhere
				deferred.reject(resp.msg);
			}

		});

		return deferred.promise;
	}

	// check for domain
	service.checkTld = function(domain) {
		if (deferred) {
			deferred.reject();
		}

		deferred = $q.defer();

		ajaxCall('/domains/available', 'POST', JSON.stringify({ "domain": domain, "any_tld": "yes" }), function(resp){
			deferred.resolve(resp);
		});

		return deferred.promise;
	}

	// stop all http requests
	service.stop = function() {
		canceller.resolve();
		$rootScope.ajax = false;
	}

	// register domain
	service.registerDomain = function(data, category, purpose) {
		if (deferred) {
			deferred.reject();
		}

		deferred = $q.defer();

		// convert data from angular to object
		data = angular.copy(data);

		void 0;

		// add some specialties
		data.services = {
			'dns': 'simple-dns-p00',
			'domain': 'domain-' + $rootScope.selectedDomain.TLD
		};

		// prepare additional data
		data.additional_data = {};
		if (typeof category != 'undefined' && category != null) {
			data.additional_data.category = category;
		}

		if (typeof purpose != 'undefined' && purpose != null) {
			data.additional_data.purpose = purpose;
		}

		void 0;

		// perform actual registration
		ajaxCall('/register/existing', 'POST', JSON.stringify(data), function(resp) {
			deferred.resolve(resp);
		});

		return deferred.promise;
	}

	function ajaxCall(url, method, data, callback) {
		$http.defaults.useXDomain = true;
		$http.defaults.headers.common['X-Bottle-Cap'] = POP.bottleCap;
		$rootScope.ajax = true;

		canceller = $q.defer();

		$http({
			url: POP.apiBaseUrl + url,
			method: method,
			data: data,
			withCredentials: true,
			timeout: canceller.promise,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			}
		}).success(function(resp) {
			callback(resp);
			$rootScope.ajax = false;
		}).error(function(resp) {
			callback(resp);
			$rootScope.ajax = false;
		});
	}

	service.data = function() {
		return data;
	};

	return service;
});

/**
 * TLD pop up directive.
 */
domainApp.directive('tldSearch', function(domainService) {
	return {
		require: 'ngModel',
		link: function(scope, el, attrs, ctrl) {
			var $el = angular.element(el[0]),
				tlds,
				timeout = null,
				el_padding,
				visible = false,
				validDomainRegex = '^[a-zA-Z0-9\\-]+\\..+$',
				validDomainRegexNoTld = '^[a-zA-Z0-9\\-\\s]+$',
				validationRegex = '',
				tldValue = '';

			// watch scope.tlds to update validator regex
			scope.$watch('tlds', function(newValue) {
				var list = '';

				if (newValue) {
					// update regex with values
					for(var i=0;i<newValue.length;i++) {
						list += newValue[i].attributes.tld + ((i < newValue.length-1) ? '|' : '');
					}

					validDomainRegex = validDomainRegex.replace("()","("+list+")");
				}
			});

			// watch for scope changes on the input model
			scope.$watch(attrs.ngModel, function(viewValue) {
				var len = viewValue ? viewValue.length : 0;

				// clear previous timeouts
				if (timeout) {
					clearTimeout(timeout);
					domainService.stop();
					scope.domainAvailable = false;
					scope.suggestions = [];
				}

				// check if we need to valide with a period or not
				//if (len > 0 && viewValue.indexOf(".") != -1 && viewValue.indexOf('.', len - 1) !== -1) {
				if (viewValue && viewValue.indexOf(".") != -1) {
					validationRegex = validDomainRegex;
				} else {
					validationRegex = validDomainRegexNoTld;
				}

				// validate it
				var regex = new RegExp(validationRegex,'g');
				if (regex.test(viewValue)) {
					// it is valid
					ctrl.$setValidity('validUrl', true);

					// reset messaging
					domainService.showMessage('#messageBox', [], 'default');
				} else {
					// it is invalid
					ctrl.$setValidity('validUrl', false);

					domainService.showMessage('#messageBox', [scope.messages['domainError']], 'danger');
					return;
				}

				// just in case we came back from a route and populated domain, don't search yet
				if (scope.dontSearch) {
					// reset flag so we can search, yo
					scope.dontSearch = false;
					return;
				}

				// finally, check if viewvalue length >= 2
				if (viewValue && viewValue.length > 2) {
					timeout = setTimeout(function(){
						domainService.stop();
						checktld(viewValue);
					}, 700);
				}
			});

			function checktld(viewValue) {
				scope.suggestions = [];

				//go find us a valid domain name
				domainService.checkTld(viewValue).then(function(resp){
					void 0;

					var msgs = [];
					if (resp != null) {
						if (resp.code == 200) {
							if (resp.available === true) {
								// found a valid domain!
								//msgs.push(scope.messages["available"]);

								// display message
								domainService.showMessage('#messageBox', msgs);

								if (resp.similar_domains.length > 0) {
                                    //default domain!
                                    msgs.push(scope.messages["available_similar"]);

	                            	// display message
	                            	domainService.showMessage('#messageBox', msgs);

									//display "domainAvailable" tile
									scope.domainAvailable = resp.similar_domains.shift();
								} else {
									//default domain!
									msgs.push(scope.messages["notavailableempty"]);

									//display message
									domainService.showMessage('#messageBox', msgs, 'warning');

									scope.domainAvailable = null;
								}

								if (resp.additional_data) {
									scope.domainAvailable.additional_data = resp.additional_data;
								}
							} else {
								if (resp.similar_domains.length > 0) {
									// default domain!
									msgs.push(scope.messages["notavailable"]);
								} else {
									msgs.push(scope.messages["notavailableempty"]);
								}

								// display message
								domainService.showMessage('#messageBox', msgs, 'warning');

								scope.domainAvailable = null;
							}
						} else if(resp.code == 400) {
							if (resp.max_signups === true) {
								msgs.push(resp.msg);
							} else {
								if (resp.available === false) {
									msgs.push(scope.messages["notavailable"]);
								}

								if (resp.blacklisted === true) {
									msgs.push(scope.messages["blacklisted"]);
								}

								if (resp.gapps === true) {
									msgs.push(scope.messages["gapps"]);
								}
							}

							// display message
							domainService.showMessage('#messageBox', msgs, 'danger');
						}

						// regardless of response, always show suggestions (limit to 20?)
						scope.suggestions = resp.similar_domains;
					}
				},
				function(error){
					void 0;
				});
			}
		}
	}
});

(function($) {
     $.fn.textWidth = function () {
		$body = $('body');
		$this =  $(this);
		$text = $this.text();
		if($text=='') $text = $this.val();
		var calc = '<div style="clear:both;display:block;visibility:hidden;"><span style="width;inherit;margin:0;font-family:'  + $this.css('font-family') + ';font-size:'  + $this.css('font-size') + ';font-weight:' + $this.css('font-weight') + '">' + $text + '</span></div>';
		$body.append(calc);
		var width = $('body').find('span:last').width();
		$body.find('span:last').parent().remove();
		return width;
    };
 })(jQuery);
